import { createFileRoute } from '@tanstack/react-router';
import { BenefitCatalogRevisionEditPage } from '../../../edit/BenefitCatalogEditPage';

export const Route = createFileRoute(
  '/_protected/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/edit/',
)({
  component: BenefitCatalogRevisionEditPage,
});
